import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

const img = (name) => `${process.env.PUBLIC_URL}/images/accommodation/${name}`;
const ACCOMMODATION_FORM_XLSX = `${process.env.PUBLIC_URL}/accommodation/accommodation_form.xlsx`;

const Accommodation = () => {
  return (
    <React.Fragment>
      <SEO title="Accommodation | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Accommodation"
        content="For Participants"
        contentTwo="Accommodation"
        linkage="/"
      />

      <EmptyTwo>
        <div className="entry-content accommodation-page">
          <section className="accommodation-section">
            <h1>ICSI 2026 Recommended Hotels</h1>
            <p>
              ICSI&apos;2026 <strong>recommends Jinniu Hotel (金牛宾馆)</strong>, the conference
              venue, for its convenience — registration, technical sessions, meals, and social
              events all take place within the hotel complex.
            </p>
            <p>
              The organizing committee has negotiated <strong>conference preferential rates</strong>{" "}
              at Jinniu Hotel for registered participants. Booking through the conference is
              optional; you may also stay at other hotels in the surrounding area according to
              your own preferences.
            </p>
          </section>

          <section className="accommodation-section">
            <h2>Conference Preferential Rates &amp; Booking</h2>
            <p>
              Two room types are available under the conference agreement. Registered authors and
              participants who wish to book may click <strong>Book Now</strong> to complete the
              accommodation survey. The secretariat will use your responses to coordinate
              reservations with Jinniu Hotel.
            </p>
            <div className="accommodation-rates">
              <div className="accommodation-rate-card">
                <h3>Option A — RMB 400 / night</h3>
                <p><strong>Room type:</strong> Standard twin room (标间)</p>
                <p><strong>Location:</strong> Old Garden Area (老区域)</p>
                <p>
                  A comfortable standard twin room within the hotel&apos;s established garden
                  complex, close to main conference facilities.
                </p>
              </div>
              <div className="accommodation-rate-card">
                <h3>Option B — RMB 680 / night</h3>
                <p><strong>Room type:</strong> Single room</p>
                <p><strong>Location:</strong> New Villa Area (新别墅区)</p>
                <p>
                  A single room in the hotel&apos;s newer villa section, offering a quieter and
                  more private stay within the conference grounds.
                </p>
              </div>
            </div>
            <p>
              <em>
                Booking through the conference is optional. If you prefer to arrange your own
                lodging, you are welcome to book any hotel nearby on your own.
              </em>
            </p>
            <p>
              If the online survey is not accessible in your region, you may{" "}
              <a href={ACCOMMODATION_FORM_XLSX} download>
                download this Excel form
              </a>
              , fill it in, and email it to{" "}
              <a href="mailto:icsi2026@iasei.org">icsi2026@iasei.org</a>.
            </p>
            <Link
              className="btn btn-primary mt-s accommodation-btn"
              to={process.env.PUBLIC_URL + "/accommodation_book"}
            >
              Book Now
            </Link>
          </section>

          <section className="accommodation-section hotel-card">
            <h2>Recommended: Jinniu Hotel (金牛宾馆)</h2>
            <div className="accommodation-gallery">
              <img src={img("room-1.jpg")} alt="Guest room at Jinniu Hotel" />
              <img src={img("room-2.jpg")} alt="Guest room with garden view" />
              <img src={img("room-3.jpg")} alt="Suite bathroom and bedroom" />
              <img src={img("room-4.jpg")} alt="Deluxe guest room" />
            </div>
            <div className="accommodation-details">
              <p>
                <strong>Address:</strong> No. 2, Outer West Jinquan Road, Jinniu District,
                Chengdu, Sichuan 610036, China
              </p>
              <p>
                <strong>Telephone:</strong> +86-28-87306770 / +86-28-87306003
              </p>
              <p><strong>About the Hotel:</strong></p>
              <ul>
                <li>
                  A renowned garden-style state guesthouse in Chengdu, established in 1957 and
                  renovated in recent years
                </li>
                <li>
                  Set in a 730-acre landscaped estate with lakes, villas, and conference facilities
                </li>
                <li>
                  Offers comfortable guest rooms, banquet halls, restaurants, and full conference
                  support
                </li>
                <li>
                  Convenient access to Chengdu metro stations and major transport hubs
                </li>
              </ul>
              <a
                href="https://anyee.com/jinniu/"
                className="btn btn-primary mt-s accommodation-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Hotel Information
              </a>
            </div>
          </section>

          <section className="accommodation-section">
            <h3>Other Hotels Nearby</h3>
            <p>
              Chengdu offers a wide range of hotels near Jinniu Hotel and throughout the city.
              Delegates who do not use the conference preferential rate may arrange lodging through
              their preferred channels.
            </p>
            <p>
              <em>
                Tip: Booking early is advisable, as July is a popular travel season in Chengdu.
              </em>
            </p>
          </section>

          <section className="accommodation-section">
            <h3>Hotel Map (Reference)</h3>
            <p>
              The map below shows the main buildings within Jinniu Hotel for delegates who choose
              to stay at the conference venue.
            </p>
            <img
              className="accommodation-image"
              src={img("hotel-map.jpg")}
              alt="Jinniu Hotel map"
            />
          </section>
        </div>
      </EmptyTwo>

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Accommodation;
